export function setCookie(cname, cvalue, exdays = 365) {
    const d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    const expires = "expires=" + d.toUTCString();

    document.cookie = `${cname}=${cvalue};${expires};path=/;domain=.dc-test.de`;
    document.cookie = `${cname}=${cvalue};${expires};path=/;domain=.ariva.ch`;
    document.cookie = `${cname}=${cvalue};${expires};path=/;`;
}

export function getCookie(cname) {
    const name = cname + "=";
    const decodedCookie = decodeURIComponent(document.cookie);
    const ca = decodedCookie.split(';');
    for (let c of ca) {
        while (c.charAt(0) === ' ') c = c.substring(1);
        if (c.indexOf(name) === 0) return c.substring(name.length);
    }
    return "";
}

export function deleteCookie(cname) {
    const expires = "expires=Thu, 01 Jan 1970 00:00:00 UTC";
    document.cookie = `${cname}=;${expires};path=/;domain=.dc-test.de`;
    document.cookie = `${cname}=${expires};${expires};path=/;domain=.ariva.ch`;
    document.cookie = `${cname}=;${expires};path=/;`;
}